/*
 * assets/wubs-apply.js (v0.1)
 * Custom expert application form. Validerar och POST:ar JSON till Lovable
 * via App Proxy (data-endpoint). Lovable skapar Shopify Customer + Company
 * (name = company_name, or the person's name when blank) as NOT order-approved,
 * plus en pending expert_application. Visar success/error i temat.
 */
(function () {
  'use strict';
  if (customElements.get('wubs-apply-form')) return;

  customElements.define(
    'wubs-apply-form',
    class WubsApplyForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.successEl = this.querySelector('[data-wx-success]');
        this.errorEl = this.querySelector('[data-wx-error]');
        this.submitBtn = this.querySelector('.wx-form-submit');
        this.endpoint = this.dataset.endpoint || '/apps/norsan-expert/apply';
        if (this.form) this.form.addEventListener('submit', this._onSubmit.bind(this));
      }

      _onSubmit(e) {
        e.preventDefault();
        this._clearInvalid();
        this._hideError();

        if (!this.form.checkValidity()) {
          this._markInvalid();
          this._showError('Please complete the required fields.');
          return;
        }

        var data = {};
        new FormData(this.form).forEach(function (v, k) { data[k] = typeof v === 'string' ? v.trim() : v; });
        data.consent = !!this.form.querySelector('[name="consent"]:checked');
        // One checkbox covers both the terms and the newsletter, so the same
        // tick answers both fields.
        data.marketing_consent = data.consent;

        this._setLoading(true);
        var self = this;

        fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
          body: JSON.stringify(data)
        })
          .then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, body: j }; });
          })
          .then(function (res) {
            if (res.ok && res.body.ok !== false) {
              self._showSuccess();
            } else {
              self._setLoading(false);
              self._showError(res.body.error || 'Something went wrong submitting your application. Please try again.');
            }
          })
          .catch(function () {
            self._setLoading(false);
            self._showError('Network error. Please check your connection and try again.');
          });
      }

      _setLoading(on) {
        var txt = this.submitBtn.querySelector('.wx-form-submit-txt') || this.submitBtn;
        if (on) {
          this.submitBtn.dataset._orig = txt.textContent;
          txt.textContent = 'Submitting…';
          this.submitBtn.disabled = true;
        } else {
          if (this.submitBtn.dataset._orig) txt.textContent = this.submitBtn.dataset._orig;
          this.submitBtn.disabled = false;
        }
      }

      _showSuccess() {
        if (this.form) this.form.hidden = true;
        if (this.successEl) {
          this.successEl.hidden = false;
          this.successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      _showError(msg) {
        if (!this.errorEl) return;
        this.errorEl.textContent = msg;
        this.errorEl.hidden = false;
      }
      _hideError() { if (this.errorEl) this.errorEl.hidden = true; }

      _markInvalid() {
        var els = this.form.querySelectorAll('input, select, textarea');
        var firstBad = null;
        els.forEach(function (el) {
          if (!el.checkValidity()) {
            var field = el.closest('.wx-field') || el.closest('.wx-consent');
            if (field) field.classList.add('is-invalid');
            if (!firstBad) firstBad = el;
          }
        });
        if (firstBad) firstBad.focus();
      }
      _clearInvalid() {
        this.querySelectorAll('.is-invalid').forEach(function (f) { f.classList.remove('is-invalid'); });
      }
    }
  );
})();
